export default (arr, id) => arr.find((el) => el.id === parseInt(id, 10));
